import { AppService } from "app/services/app.service";

import AssembleiaItemDiscuta from "app/models/assembleia/assembleiaItemDiscuta.model";

export abstract class AbAssembleiaItemDiscuta extends AppService {
  abstract salvarAlterarDados(entity: AssembleiaItemDiscuta);
  abstract getAllItemDiscuta(itemId: number);
}